import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { SYSTEM_CONFIGURATION_ITEM } from '../../../interfaces'
import { UISchemaService } from 'Admin/services/ui.schema.service';
import { Router } from '@angular/router';

import { MQService, MQComponent, MQMessage } from '@ngxsuit'
import { StoreService } from "Admin/services"

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent extends MQComponent implements OnInit {
    isActive = false;
    showMenu = '';
    menus:SYSTEM_CONFIGURATION_ITEM[] = [];
    selected:string = '';

    private currentStoreName: string = "default";
    
    constructor(private uischema: UISchemaService, 
        private storeService: StoreService,
        private router: Router,
        protected mq:MQService ) {
        super(mq);
    }

    ngOnInit() {
        super.listenOn('ui-schema-json-ready', (msg:MQMessage) => {
            this.menus = msg['navitems'];
        });
      
        this.uischema.useUISchemaWhenReady(navitems => {
            this.menus = navitems;
        });

        super.listenOn('store-changed', resp => {
            if (resp && resp['store']) {
                this.currentStoreName = resp['store']['name'];
            }
        })
    }

    onClickRouteLink(menu) {
        this.selected = menu.name; 
        if (menu.absolute) { 
            window.location.href = menu.link; 
        }
    }

    changeStore(storeName) {
        if (this.currentStoreName !== storeName) {
            this.storeService.changeStore(storeName, this.router);
        }
        this.selected = '';
    }
}
